import { ThemeComponent } from "@/theme/ThemeComponent";
import { html, render } from "lit-html";
import { cart } from "@/theme/Cart";
import { CartItem, Component, dump, Prop, Ref } from '@eastsideco/salvo-ts';
import { QuantitySpinner } from "../QuantitySpinner/QuantitySpinner";
import { formatPrice} from "@/utils/products";


@Component
export class CartItemRow extends ThemeComponent {
    private quantity: QuantitySpinner;

    constructor(item: CartItem, quantity: QuantitySpinner, strings: string) {
        super();
        this.quantity = quantity;
        this.render(item, quantity, strings);
    }

    render(item: CartItem, quantity: QuantitySpinner, strings: string) {
        render(html`
            <div class="cart-row">
                <a href="${item.url}" class="cart-row__image object-cover">
                    <img src="${item.image}" alt="${item.title}">
                </a>
                <div class="cart-row__information">
                    <div class="cart-row__info-top">
                        <h3 class="cart-row__title body-2">${item.title} </h3>
                        <p class="cart-row__quantity body-2" data-id="${item.id}">
                            ${quantity}
                        </p>

                        <p class="cart-row__price">
                            ${ formatPrice(item.linePrice, String(JSON.parse(strings).moneyFormat))}
                        </p>
                    </div>

                    <div class="cart-row__info-bottom">
                        <div  class="cart-row__update">
                            <button 
                                class="cart-row__remove meta" 
                                data-ref="removeItem" 
                                data-item="${item.variantId}"
                            >
                                ${JSON.parse(strings).remove}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        `, this);
    }

    @Ref() removeItem!: HTMLButtonElement;

    /**
     * Initialise.
     */
    init() {
        this.$listen(this.removeItem, 'click', () => this.handleRemoveItem(this.removeItem));
        this.$subscribe(this.quantity.onChange, (value) => this.handleQuantity());
    }

    /**
     * Remove item from cart.
     * @param target - remove button.
     */
    handleRemoveItem(target: HTMLElement) {
        if (target.dataset.item === undefined) { return; }

        for (const item of cart.items) {
            if (~~item.id === ~~target.dataset.item) {
                try {
                    cart.removeItem(item).catch((event: unknown) => {
                        if (event instanceof Error) {
                            this.$log.error(event.message);
                        }
                    });

                } catch (event: unknown) {
                    if (event instanceof Error) {
                        this.$log.info('Remove error', event.message);
                    }
                }
            }
        }
    }

    /**
     * Handle cart quanitty Change.
     */
    handleQuantity() {
        if(this.quantity === null || this.quantity.parentNode === null ) { return; }

        if (this.quantity.parentNode instanceof HTMLElement) {
            if(this.quantity.parentNode.dataset.id == null) { return; }
            const itemId = this.quantity.parentNode.dataset.id;

            for (const item of cart.items) {
                if (+item.id === +itemId) {
                    const quantity = +this.quantity.input.value;

                    try {
                        cart.changeItem(item, quantity, null).catch((event: unknown) => {
                            if (event instanceof Error) {
                                this.$log.error(event.message);
                            }
                        });

                    } catch (event: unknown) {
                        const { message } = event as Error;
                        this.$log.info('Quantity error', message);
                    }
                }
            }
        }
    }
}

